import { memo } from "react";
import ReservationPlugin from "@reservation2/ReservationPlugin.tsx";

const ReservationView = () => {
  return (
    <ReservationPlugin/>
  )
}

export default memo(ReservationView)